import React from 'react';
import { FadeIn } from '../FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsAHA() {
  const benefits = [{
    title: 'Instrumente rapide pentru momentele grele',
    desc: 'știi ce să faci în 30 de secunde când valul urcă, nu trebuie să cauți pe Google la miezul nopții'
  }, {
    title: 'Trei tehnici de respirație testate',
    desc: 'pentru trei tipuri diferite de emoții: panică, furie, deconectare'
  }, {
    title: 'Workbook PDF de 13 pagini',
    desc: 'cu spațiu pentru journaling, reamintiri și exerciții practice'
  }, {
    title: 'Fișă personală de urgență emoțională',
    desc: 'scrisă de tine pentru tine, care îți amintește ce funcționează atunci când mintea nu mai poate să își amintească singură'
  }, {
    title: 'Acces pe viață la audio-uri',
    desc: 'ca să le poți reasculta de câte ori ai nevoie'
  }, {
    title: 'Acces în Grupul Cicatricilor',
    desc: 'comunitatea privată unde nimeni nu te judecă pentru ce simți'
  }, {
    title: 'Un ritm pe care îl alegi tu',
    desc: 'un modul pe zi, unul pe săptămână, sau ritmul care ți se potrivește'
  }];
  return <section id="beneficii" className="py-20 md:py-28 bg-white overflow-hidden" data-id="element-82">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-83">
        <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-84">
          <FadeIn data-id="element-85">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-86">
              Ce obții concret prin acest curs
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-87">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-88">
              <div className="bg-ivory/50 border border-gold/20 rounded-[20px] p-8 h-full flex items-start gap-5 hover:bg-ivory transition-colors duration-300" data-id="element-89">
                <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-90">
                  <CheckCircle2 className="w-5 h-5 text-gold-dark" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <h3 className="text-[19px] font-medium text-forest mb-2" data-id="element-93">
                    {benefit.title}:
                  </h3>
                  <p className="text-[18px] text-charcoal/70 leading-relaxed" data-id="element-94">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}